import { useEffect, useMemo, useRef, useState } from "react";
import { AwButton, AwCard, AwFormFieldWrapper, AwGenericPModal, AwIcon, AwMinMaxDateField, AwPresentationalModal, AwSelectBox, useAxiosFunc, useForm } from "../../../components"
// import { states } from "../../../defs"
import { arrayToObject, awIcons, getKeysWithoutIds, isResponseError, reportDateUtc } from "../../../utils";
import api from "../../../store/api";
import { AppLoadingSpinner } from "../../../PreApp";
import { FontAwesomeIcon } from "../../../third-party-lib";
import { AwModalPItem } from "../../../components/modal/AwModalPItem";



const cache = {};
const getInitDate = (days: number) => new Date(new Date().setDate(new Date().getDate()-days))
const reportTypes = [{Key: 'Reported', Value: 'reported'}, {Key: 'Unreported', Value: 'unreported'}, {Key: 'Both', Value: 'both'}];

export const ReportSummary = () => {
    const preselect = "AK";
    const baseUrl = '/api/reported/ReportSearch';
    const [state, setStateProvince] = useState<any>(null);
    const [reportType, setReportTypes] = useState<any>(reportTypes[2].Value);
    const keysRef = useRef(getKeysWithoutIds({
        AsapStandard: '',
        IsManufactured: true, 
        Notes: "", 
        RxNumber: 0, 
        ShippingDate: '', 
        StateProvinceId: ''
    }));
    const [dates, setDates] = useForm({StartDate: getInitDate(7), EndDate:  getInitDate(1)})
    const [isLoading, setLoading] = useState(true);
    const [rxes, setRxes] = useState<any>();
    const comp = useRef({isActive: true}).current;
    const maxDate = getInitDate(1);
    const { res, reLoadData } = useAxiosFunc(
        `api/PharmacyStateSettings?pharmacyId=${1}`,
        []
    );
    const { states, newStates } = useMemo(() => {
    const copy = JSON.parse(JSON.stringify(res.data));
    const modified = arrayToObject(copy, "StateProvinceId");
    const selectedId = !!state ? state.StateProvinceId : preselect;
    setStateProvince(modified[selectedId]);
    return { states: copy, newStates: modified };
    }, [res]); // Added settings as dep to avoid warnings
    
    const onStateChange = (stateId: any) => {
        const stateObj = newStates[stateId];
        setStateProvince(stateObj);
        if(state) {
            searchReportAsync(getUrl(stateObj.StateProvinceId));
        }
    };

    const onReportTypeChange = (rt: any) => {
        setReportTypes(rt);
    }
    
    const handleDates = (e: any) => {
        setDates(e);
    }
    
    const handleLoading = () => {
        setLoading(x => !x);
    }

    const getUrl = (stateProvinceId: string = '') => {
        // const d = endDateExclusive(dates.EndDate)
        // const endDate = reportDateUtc(d.toDate())
        if(!stateProvinceId) {
            stateProvinceId = state.StateProvinceId;
        }
        return `${baseUrl}?startDate=${reportDateUtc(dates.StartDate)}&endDate=${reportDateUtc(dates.EndDate)}&stateProvinceId=${stateProvinceId}&typeOfReport=${reportType}`
    };
    const searchReportAsync = async (url: string = '') => {
        if(!isLoading) handleLoading();
        var response = await api.requestmethods.get(url || getUrl());
        const isError = isResponseError(response);
        handleLoading();
        if(!isError) {
            (cache as any)[baseUrl] = response;
            if(comp.isActive) setRxes(response);
        }
    }
    const seeInfo = () => {
        console.log(rxes);
    }

    const checkValue = (str: any) => {
        let output = false;
        const newStr = str.toLowerCase();
        if (newStr.indexOf("date") !== -1) {
        output = true;
        }
        return output;
    };

    useEffect(() => {
        handleLoading();
        onStateChange(preselect);
    }, [])

    return (
        <>
        <style>{`
            .search-filters {
                display: flex;
                gap: 15px;
            }
            .search-filters > div:first-child {
                width: 250px;
            }
            .search-filters .dates {
                display: flex;
                align-items: center;
                gap: 15px;
            }
            .search-filters .dates label {
                margin-bottom: 0;
                margin-right: 10px;
            }
            .search-filters .reporttypes + div {
                display: flex;
                align-items: center;
                height: 40px;
            }
            .search-filters .reporttypes > div {
                width: 150px;
            }

            .p-modal .modal-content {
                max-height: 80vh;
            }
            .p-modal .modal-body {
                overflow: hidden;
                overflow-y: auto;
            }
      `}</style>
        <div>
            <AppLoadingSpinner loaded={!isLoading} bgClr='rgba(255, 255, 255, 0.2)'>
                <div className="search-filters">
                    <AwSelectBox
                        {...{
                        array: states, 
                        value: "StateProvinceId",
                        label2: "StateName",
                        label: "StateProvinceId",
                        dValue: preselect,
                        onSelectValueChange: onStateChange
                        }} />

                    <div className='dates'>
                        <AwMinMaxDateField onDateSelected={handleDates} label={"Start"} type={"StartDate"} isVertical={false} init={dates.StartDate} maxDate={maxDate} />
                        <AwMinMaxDateField onDateSelected={handleDates} label={"End"} type={"EndDate"} isVertical={false} init={dates.EndDate} maxDate={maxDate} />
                    </div>
                    
                    <div className="reporttypes">
                        <AwSelectBox
                            {...{
                            array: reportTypes, 
                            value: "Value",
                            label: "Key",
                            dValue: reportType,
                            onSelectValueChange: onReportTypeChange
                            }} />
                    </div>

                    <div>
                        <AwButton ref={null} {...{label: "Search", btnClicked: searchReportAsync}} />
                    </div>
                </div>

                <div className="search-filters-body" style={{marginTop: '2rem'}}>
                    {rxes && (<>
                        <AwCard {...{label: state.StateName + " (" + rxes.AsapStandard + ")", labelKey: state.StateProvinceId}}>
                            <div>
                                <p>Is All Scripts Controlled? <b>{rxes.ControlledRxOnly ? 'Yes' : 'No'}</b></p>
                                <p>Total Order Items: <b>{rxes.Total}</b></p>
                                <p>Order Items Submitted: <b>{rxes.SubmittedCount}</b></p>
                                <p>
                                    Order Items Not Submitted: <b>{rxes.NotSubmittedCount}</b>
                                    
                                    {rxes.NotSubmittedCount > 0 && (
                                        <AwGenericPModal title="Rx Not Reported" queryAsync={() => seeInfo()}>
                                            <>
                                                <span style={{marginLeft: '15px'}} className="ui circular mini button">
                                                    <FontAwesomeIcon icon={awIcons.info as any} />
                                                </span>
                                            </>
                                            <>
                                                {rxes.OrderItemsSummary.map((data: any, i: number) => (
                                                    <div key={data.RxNumber ?? i}>
                                                        {/* <b>{i}</b> */}
                                                        {keysRef.current?.map((str) => {
                                                            return (
                                                                <AwModalPItem
                                                                    key={str}
                                                                    label={str}
                                                                    value={data[str]}
                                                                    isDate={checkValue(str)}
                                                                />
                                                            )
                                                        })}
                                                        {((rxes.OrderItemsSummary.length - 1) != i) && (
                                                            <p>--------------------------------------------------------</p>
                                                        )}
                                                    </div>
                                                ))}
                                            </>
                                        </AwGenericPModal>
                                    )}
                                </p>
                                <p>Total Orders: <b>{rxes.OrderCount}</b></p>
                            </div>
                        </AwCard>
                    </>)}
                </div>
                
            </AppLoadingSpinner>
        </div>
        </>
    )
}

